import { connect } from "react-redux";

import { showNotification } from "../../../../store/notification/actions";

import loadableComponent from "./loadable";

export default connect(null, { showNotification })(loadableComponent);
